import type { FaireProductEntity } from "../../entity_types/product";

export const p_88qwxx7dga: FaireProductEntity = {
  token: "p_88qwxx7dga",
  type: "product",
  name: "Bold Stainless Steel Dome Wave Ring – Gold & Silver",
  brandToken: "b_wxdny9yjk7",
  brandName: "Norelle",
  imageUrl:
    "https://cdn.faire.com/fastly/82a071dfc5b96ac18b3721314cc38016ab02a2001f071879563f4826e8c76ff5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ffb48bd931b97e5da496cebc80375fb4bfd9adfeb6722eae7a577878de62f68c.jpeg",
    "https://cdn.faire.com/fastly/f4a034e3387f65fe390efd9141f4e5b1603b6c7185cb427616ae1eb5583a4549.jpeg",
    "https://cdn.faire.com/fastly/7573da8567cf8ef0ba06281609273f74139e4fe40e030efb29e6d8484bbe9104.jpeg",
    "https://cdn.faire.com/fastly/6026519641d948f579e72c7798c92881363169f53705cef84cee002202b53a21.jpeg",
    "https://cdn.faire.com/fastly/9c14960180991263697037a16ccbe1b3e63549145fc3c992d885788df4bce349.jpeg",
    "https://cdn.faire.com/fastly/285f56188db63415d88a225d600316aa5ef785adb2831011f90fcad73d5f04bc.jpeg",
    "https://cdn.faire.com/fastly/835a8ff565517f76b682b6aef9a15979b1603e5c58469382ad81f670ef6af7b3.jpeg",
  ],
  priceDollars: 6.9,
  description:
    "This modern dome wave ring combines sculptural design with everyday wearability. Its fluid, rounded shape makes it a versatile accessory — whether styled as a statement ring or paired with other minimalist bands.\n\n2 Color Options: High-polish gold and sleek silver finishes.\n3 Sizes: US 6, US 7, US 8 — easy fit for most customers.\nMaterial: Premium stainless steel for durability. (18K Gold-Plated for Gold Option)\nFeatures: Waterproof, tarnish-resistant, and hypoallergenic.\n\nDesigned for boutiques seeking a contemporary bestseller, this ring is lightweight, comfortable, and suitable for both casual styling and elevated outfits.\n\nDimensions & Weight\nWidth: 0.31 in\nWeight: 0.22 oz\nAvailable Sizes: US 6 / US 7 / US 8",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:15.603Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
